import React, { Suspense, lazy } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";


const AU = lazy(() => import("../../ContactUs/EnquireForm"));
const FR = lazy(() => import("../../ContactUs/EnquireFormFR"));
const PT = lazy(() => import("../../ContactUs/EnquireFormPT"));

const EnquireFormLoader = () => {
    const region = useSelector((state: RootState) => state.region.region);

    return (
        <Suspense fallback={<Spinner animation="border" variant="light" />}>
            <>
                {region === "AU" && <AU />}
                {region === "FR" && <FR />}
                {region === "PT" && <PT />}

            </>
        </Suspense>
    );
}

export default EnquireFormLoader;